import { render, staticRenderFns } from "./tablesPerusahaan.vue?vue&type=template&id=77a422f1&scoped=true"
import script from "./tablesPerusahaan.vue?vue&type=script&lang=js"
export * from "./tablesPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./tablesPerusahaan.vue?vue&type=style&index=0&id=77a422f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a422f1",
  null
  
)

export default component.exports